import actions from './store/actions';
import { is, omit } from 'ramda';
import { Map } from 'immutable';
import { isUsDomain } from 'synergycms_core/src/utils';

const {
  langInfo: langActions,
  webType: webTypeActions,
  googleApiKey: GoogleApiKeyActions,
  currentHotel: currentHotelAction,
} = actions.customer;

const appActions = actions.app;
const groupActions = actions.group;
const hotelsActions = actions.hotels;

export const getParamsFromWindow = queryObj => {
  if (!queryObj.get('hotelCode') && !queryObj.get('hotelCodes')) {
    const hotelCode = window.frontLoader?.hotel_code || window.hotel_code
    const hotelId = window.frontLoader?.hotel_id || window.id_hotel
    if (hotelCode) {
      return queryObj.set('hotelCode', hotelCode);
    } else if (hotelId) {
      return queryObj.set('hotelId', hotelId);
    }
  }
  return queryObj;
};

const initializeStore = (baseRoute, arrayHash, queryObj, dispatch) => {
  const defaultState = (window.frontLoader && window.frontLoader['cms-avail']?.defaultState) || window.defaultState;

  window.availabilityReactTestingMode = is(Map, queryObj) && !!queryObj.get('testing_mode', false);

  let  windowConfig = {}
  if (window.frontLoader && window.frontLoader['cms-avail']) {
    windowConfig = {
      ...window.frontLoader['cms-avail'],
      ...(window.frontLoader.hotels_info && { hotels_info: window.frontLoader.hotels_info }),
      ...(window.frontLoader.lang_info && { lang_info: window.frontLoader.lang_info }),    
      ...(window.frontLoader.group && { group: window.frontLoader.group}),
      ...(window.frontLoader.countries && { countries: window.frontLoader.countries}),
      ...(window.frontLoader.web_type && {web_type: window.frontLoader.web_type}),
      ...(window.frontLoader.hotel_id && {hotel_id: window.frontLoader.hotel_id}),
      ...(window.frontLoader.hotel_code && {hotel_code: window.frontLoader.hotel_code}),
      
      ...(window.frontLoader.currency_code && {currency_code: window.frontLoader.currency_code}),
    }
  } else if (window.engine_sygy_data) { //TODO. Eliminar condicional tras migrar engine_sygy_data a frontLoader
     windowConfig = {
      ...window.engine_sygy_data,
      config: {
        ...omit(['lang_info', 'avail_url', 'url', 'i18n', 'config', 'currencies', 'group', 'web_type', 'hotel_id', 'hotel_code'], window.engine_sygy_data),
        ...window.engine_sygy_data.config
      }
    }
  }

  const webType = windowConfig.web_type || window.web_type
  const hotId = windowConfig.hotel_id || window.id_hotel || window.hotel_id
  const hotCode = windowConfig.hotel_code || window.hotel_code
  const group = windowConfig.group || window.hotelGroup 
  const hotelsInfo = windowConfig.hotels_info || window.hotels_info 
  const langInfo = windowConfig.lang_info || window.lang_info
  const countries = windowConfig.countries || window.countries

  dispatch(appActions.name.get("avail"));
  
  if (windowConfig.config) {
    if (!hotelsInfo && hotId) {
      dispatch(appActions.config.getHotel(hotId, windowConfig.config));
    }else{
      dispatch(appActions.config.get(windowConfig.config));
    }
  }


  // Procedimientos que se deben de hacer antes de pasar hotels info a la store, lo hacemos de esta manera para arreglar todo de un solo bucle
  if(hotelsInfo?.hotels?.length) {
    const hotelsInfoProcedures = [];
    
    //Si los ids vienen con string, los pasaremos a entero
    if(typeof hotelsInfo.hotels[0].id === "string") {
      hotelsInfoProcedures.push('parseIdToInt')
    }

    //Si estamos en el dominio .US, quitaremos las estrellas
    if(isUsDomain()){
      hotelsInfoProcedures.push('removeUSstars')
    }

    //Si tenemos procedimientos que hacer, procedemos a modificar hotels_info
    if(hotelsInfoProcedures.length) {
      hotelsInfo.hotels = hotelsInfo.hotels.map(hotel => {
        let newHotel = {...hotel};
        
        if(hotelsInfoProcedures.includes('parseIdToInt')){
          newHotel.id = parseInt(newHotel.id, 10);
        }

        if(hotelsInfoProcedures.includes('removeUSstars')){
          if(newHotel?.country_iso_code === 'US'){
            newHotel.stars = '';
          }
        }

        return newHotel;
      });
    }
  }

  //set window data
  dispatch(
    hotelsActions.info.get(
      hotelsInfo || {
        hotels: [{ id: hotId ? hotId : '', code: hotCode }]
      }
    )
  );
  dispatch(langActions.get(langInfo));
  dispatch(GoogleApiKeyActions.get(window.google_api_key));

  dispatch(webTypeActions.get(webType));
  webType === "WI" && hotId && dispatch(currentHotelAction.set(hotId))
  
  dispatch(actions.countries.get(countries, langInfo));
  dispatch(groupActions.get(group));
  dispatch(actions.system.get());

  //validacions de q l'step existeixi

  switch (defaultState.step_list) {
    case 'cancelation':
      return {
        current_step: baseRoute || defaultState.step,
        steps: [
          {
            code: 'cancelation',
            type: 'mono'
          }
        ],
        required_params: ['hotelCode', 'pin']
      };
    case 'monoHotelAvail':
      return {
        current_step: baseRoute || defaultState.step,
        steps: [
          {
            code: 'monoHotelAvail',
            type: 'mono'
          },
          {
            code: 'serviceHotelAvail',
            type: 'mono'
          },
          {
            code: 'customerForm',
            type: 'mono'
          },
          {
            code: 'confirmation',
            type: 'mono'
          }
        ],
        alter_steps: ALTER_STEPS,
        required_params: ['hotelCode', 'start', 'end', 'occups']
      };
    case 'newCof':
      return {
        current_step: baseRoute || defaultState.step,
        steps: [
          {
            code: 'newCof',
            type: 'mono'
          }
        ],
        required_params: ['id_hotel', 'pin', 'tracking_id']
      };
    case 'multiHotelAvail':
    default:
      return {
        current_step: baseRoute || defaultState.step,
        steps: [
          {
            code: 'multiHotelAvail',
            type: 'multi'
          },
          {
            code: 'monoHotelAvail',
            type: 'mono'
          },
          {
            code: 'serviceHotelAvail',
            type: 'mono'
          },
          {
            code: 'customerForm',
            type: 'mono'
          },
          {
            code: 'confirmation',
            type: 'mono'
          }
        ],
        alter_steps: ALTER_STEPS,
        required_params: ['hotelCodes', 'hotelCode', 'start', 'end', 'occups']
      };
  }
}; 

const ALTER_STEPS = {
  "noAvail": {
    code: 'noAvail',
    type: 'mono'
  }
}

export default initializeStore;
